import { EXTERIOR_WORLD } from "./generated/exterior-world.js";
function floorAt(x, z, fallback) {
    return EXTERIOR_WORLD.colliders.reduce((height, c) => c.min[0] <= x && c.max[0] >= x && c.min[2] <= z && c.max[2] >= z &&
        c.max[1] >= fallback - .1 && c.max[1] <= fallback + .1
        ? Math.max(height, c.max[1]) : height, fallback);
}
export const FRONT_DOOR_INSIDE = { x: .16, y: floorAt(.16, -.95, .74), z: -.95, facing: Math.PI, side: "inside", door: "front" };
export const FRONT_DOOR_OUTSIDE = { x: .16, y: .72, z: 1.25, facing: 0, side: "outside", door: "front" };
// Kitchen opening and the clear deck arrival are on different floor levels.
export const REAR_DOOR_INSIDE = { x: 2.26, y: floorAt(2.26, -12.25, .74), z: -12.25, facing: 0, side: "inside", door: "rear" };
export const REAR_DOOR_OUTSIDE = { x: 2.26, y: floorAt(2.26, -14, 1.18), z: -14, facing: Math.PI, side: "outside", door: "rear" };
export function insideHouse(x, y, z) {
    return EXTERIOR_WORLD.interiorEnabled && x > -4.875 && x < 4.875 &&
        z < -.125 && z > -13.075 && y > -2.4 && y < 6.34;
}
export function frontDoorDestination(x, y, z) {
    if (!EXTERIOR_WORLD.interiorEnabled || ![x, y, z].every(Number.isFinite))
        return null;
    if (Math.abs(x - .16) > .72 || Math.abs(y - .73) > .28)
        return null;
    if (z >= .25 && z <= 1.85)
        return { ...FRONT_DOOR_INSIDE };
    if (z <= -.40 && z >= -1.55)
        return { ...FRONT_DOOR_OUTSIDE };
    return null;
}
export function rearDoorDestination(x, y, z) {
    if (!EXTERIOR_WORLD.interiorEnabled || ![x, y, z].every(Number.isFinite))
        return null;
    if (Math.abs(x - 2.26) > .65)
        return null;
    if (z <= -11.85 && z >= -12.90 && Math.abs(y - REAR_DOOR_INSIDE.y) < .23)
        return { ...REAR_DOOR_OUTSIDE };
    if (z <= -13.55 && z >= -14.60 && Math.abs(y - REAR_DOOR_OUTSIDE.y) < .23)
        return { ...REAR_DOOR_INSIDE };
    return null;
}
/** Only a nearby doorway responds; other meows remain ordinary meows. */
export function doorDestination(x, y, z) {
    return frontDoorDestination(x, y, z) ?? rearDoorDestination(x, y, z);
}
/** Resolve a server door identity, retaining compatibility with old front-door messages. */
export function doorLanding(side, door = "front") {
    if (side !== "inside" && side !== "outside")
        return null;
    if (door === "front")
        return { ...(side === "inside" ? FRONT_DOOR_INSIDE : FRONT_DOOR_OUTSIDE) };
    if (door === "rear")
        return { ...(side === "inside" ? REAR_DOOR_INSIDE : REAR_DOOR_OUTSIDE) };
    return null;
}
